import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import MainLayout from "@/components/MainLayout";
import HomePage from "@/pages/HomePage";
import TestsPage from "@/pages/TestsPage";
import PackagesPage from "@/pages/PackagesPage";
import BookingPage from "@/pages/BookingPage";
import LoginPage from "@/pages/LoginPage";
import ProfilePage from "@/pages/ProfilePage";
import MyBookingsPage from "@/pages/MyBookingsPage";
import HomeCollectionPage from "@/pages/HomeCollectionPage";
import AdminPage from "@/pages/AdminPage";
import AboutPage from "@/pages/AboutPage";
import NotFound from "@/pages/NotFound";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CartProvider>
          <TooltipProvider>
            <BrowserRouter>
              <Toaster />
              <Sonner richColors position="top-right" />
              <Routes>
                <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
                <Route path="/tests" element={<MainLayout><TestsPage /></MainLayout>} />
                <Route path="/packages" element={<MainLayout><PackagesPage /></MainLayout>} />
                <Route path="/booking" element={<MainLayout><BookingPage /></MainLayout>} />
                <Route path="/login" element={<MainLayout><LoginPage /></MainLayout>} />
                <Route path="/profile" element={<MainLayout><ProfilePage /></MainLayout>} />
                <Route path="/my-bookings" element={<MainLayout><MyBookingsPage /></MainLayout>} />
                <Route path="/home-collection" element={<MainLayout><HomeCollectionPage /></MainLayout>} />
                <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </CartProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;